var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleRotate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_97_15595"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_97_15595)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.6417540234375,2.955093505859375C4.810414023437501,1.944596505859375,6.3338440234375,1.333343505859375,8.0000440234375,1.333343505859375C11.6818740234375,1.333343505859375,14.6666740234375,4.318113505859375,14.6666740234375,8.000013505859375C14.6666740234375,9.424073505859376,14.2201740234375,10.743873505859375,13.4594740234375,11.827043505859375L11.3333740234375,8.000013505859375L13.3333740234375,8.000013505859375C13.3333740234375,5.054493505859375,10.9455740234375,2.666673505859375,8.0000440234375,2.666673505859375C6.5665840234375,2.666673505859375,5.2652240234375,3.232193505859375,4.3068640234375,4.152293505859375L3.6417540234375,2.955093505859375ZM12.3582740234375,13.044943505859376C11.1896440234375,14.055443505859374,9.6662440234375,14.666643505859374,8.0000440234375,14.666643505859374C4.3181440234375,14.666643505859374,1.3333740234375,11.681843505859375,1.3333740234375,8.000013505859375C1.3333740234375,6.575913505859375,1.7799010234375001,5.256113505859375,2.5405740234375003,4.172973505859375L4.6667040234375,8.000013505859375L2.6667040234375,8.000013505859375C2.6667040234375,10.945543505859375,5.0545240234375,13.333343505859375,8.0000440234375,13.333343505859375C9.4335040234375,13.333343505859375,10.7348440234375,12.767843505859375,11.6932740234375,11.847743505859375L12.3582740234375,13.044943505859376Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRotate);
export default __webpack_public_path__ + "static/media/circle-rotate.ee715dae.svg";
export { ForwardRef as ReactComponent };